export type Benefit = { number: string; title: string; body: string };

/**
 * T872 S3 — three numbered benefits on a dark band (October delivery `BenefitItem.html`,
 * `.experience-rows`): a serif number in gold, a sans title and one line of body, ruled
 * above and below. Items arrive as data so Método and the library mount the same list.
 */
export function BenefitList({ items }: { items: Benefit[] }) {
  if (items.length === 0) return null;
  return (
    <div className="pub-benefits">
      {items.map((item) => (
        <article className="pub-benefit" key={item.number}>
          <span className="pub-benefit-number" aria-hidden="true">
            {item.number}
          </span>
          <h3>{item.title}</h3>
          <p>{item.body}</p>
        </article>
      ))}
    </div>
  );
}
